import { use } from "react";

import { mergeClassNames } from "../../utils/classes";
import { ExpandableSectionContext } from "./ExpandableSectionContext";

import type { FC, PropsWithChildren } from "react";

import * as styles from "./expandableSection.module.scss";

export interface ExpandableSectionContentProps {
	withPadding?: boolean;
}

export const ExpandableSectionContent: FC<PropsWithChildren<ExpandableSectionContentProps>> = props => {
	const context = use(ExpandableSectionContext);
	if (!context) {
		throw new Error("ExpandableSection.Content must be used within an ExpandableSection");
	}

	const children = () => (
		<div className={mergeClassNames(props.withPadding && styles.contentPadding)}>{props.children}</div>
	);

	if (!context.keepMounted) {
		if (!context.expanded) {
			return null;
		}

		return children();
	}

	return <div className={mergeClassNames(!context.expanded && styles.hidden)}>{children()}</div>;
};
